export enum ElementTitle {
  Form = "Form",
  EmbeddedVideo = "Embedded video",
  EmbeddedCode = "Embedded",
  Chart = "Chart",
  Map = "Map",
  Calendar = "Calendar",
}

export enum Settings {
  DynamicVariables = "DynamicVariables",
  FroalaEditor = "FroalaEditor",
}
export enum VideoType {
  Youtube = "Youtube",
  Code = "Code",
  Library = "Library",
  Vimeo = "Vimeo",
  Loom = "Loom",
  Vidyard = "Vidyard",
  Hippo = "Hippo",
}

export enum ChartType {
  Horizontal = "horizontal",
  Vertical = "vertical",
  Line = "line",
  VerticalLine = "vertical-line",
  Pie = "pie",
  Donut = "donut",
  HorizontalStacked = "horizontal-stacked",
  VerticalStacked = "vertical-stacked",
  HorizontalArea = "horizontal-area",
  VerticalArea = "vertical-area",
  HorizontalSmoothLine = "horizontal-smooth-line",
  VerticalSmoothLine = "vertical-smooth-line",
  VerticalSmoothArea = "vertical-smooth-area",
  HorizontalSmoothArea = "horizontal-smooth-area",
}

export type TMetadata = {
  metaTitle?: string;
  metaDescription?: string;
  metaImage?: string;
  metaIcon?: string;
  metaSiteName?: string;
  metaDomain?: string;
  isShort?: boolean;
};

// not const, cause I want to be able to use Object.values
export enum MaxWidthSettingEnum {
  narrow = "narrow",
  medium = "medium",
  wide = "wide",
  full = "full",
}
